import gql from 'graphql-tag';

export const DELAY_PAYMENT_MUTATION = gql`
  mutation DelayStatementPayment($input: DelayStatementPaymentInput!) {
    delayStatementPayment(input: $input) {
      id
    }
  }
`;

export const delayPaymentMock = {
  delayStatementPayment: {
    id: 70,
  },
};

export const DELAY_PAYMENT_REFETCH_QUERY = gql`
  query GetStatementDates($id: Int!) {
    statement(id: $id) {
      id
      paymentScheduledAt
      maxDelayDate
    }
  }
`;

export const delayPaymentRefetchQueryMock = {
  statement: {
    id: 1,
    maxDelayDate: '2020-02-17',
    paymentScheduledAt: '2020-02-15',
  },
};
